import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import BillingAddressApi from 'apis/BillingAddress';
import 'assets/scss/components/locationModal.css';
import Toaster from 'components/Toaster';

const RemoveCardModal = ({
  isVisible,
  toggleDeleteModal,
  deletingCard,
  fetchBusinessDetail,
}) => {
  const { id } = deletingCard;

  const deleteCreditCard = () => {
    BillingAddressApi.delete(id)
      .then(({ data }) => {
        Toaster.getSuccessToaster(
          'check-circle',
          'Successfully deleted payment card'
        );
        toggleDeleteModal();
        fetchBusinessDetail();
      })
      .catch(() => {
        Toaster.getErrorToaster(
          'exclamation-triangle',
          'Failed to delete card'
        );
      });
  };

  return (
    <Modal
      isOpen={isVisible}
      className="location-modal credit-card-modal"
      toggle={toggleDeleteModal}
      onClickBackdrop={toggleDeleteModal}
    >
      <ModalHeader className="text-center">
        <div className="modal-title d-inline text-bold">Remove card?</div>
        <span role="none" className="close-modal" onClick={toggleDeleteModal}>
          <FontAwesomeIcon icon="times" />
        </span>
      </ModalHeader>
      <ModalBody className="p-5">
        Are you sure you want to remove this credit card?
      </ModalBody>
      <ModalFooter>
        <button
          type="button"
          className="btn btn-danger pl-3 pr-3"
          onClick={deleteCreditCard}
        >
          Confirm
        </button>
        <button
          type="button"
          className="btn btn-transparent pl-3 pr-3"
          onClick={toggleDeleteModal}
        >
          Cancel
        </button>
      </ModalFooter>
    </Modal>
  );
};

RemoveCardModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleDeleteModal: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default RemoveCardModal;



// WEBPACK FOOTER //
// ./src/components/Modal/creditCard/deleteCreditCard.js